<app-card-content [border]="false" [headerColor]="true" icon="pi pi-graduation-cap" [title]="selectedDetail()?._type === 'GRAD' ? 'Graduação' : 'Pós-Graduação'" subtitle="Dados da formação acadêmica">
    <div card-header class="flex items-center gap-2">
        <p-button icon="pi pi-arrow-left" [text]="true" [rounded]="true" size="small" (onClick)="voltar.emit()" pTooltip="Voltar" tooltipPosition="left" />
        @if (!modoCreate()) {
            <app-botao-acoes [label]="'Ações'" [items]="acoesFormulario" [destaque]="itensEdicao" [destaqueAtivo]="modoEdicao()" [appCan]="roleFormacaoCriar" [appCanUf]="pessoa()?.uf" [permissaoUf]="pessoa()?.uf ?? null" />
        }
    </div>

    @if (selectedDetail()?._type === 'GRAD') {
        <form [formGroup]="formacaoForm">
            <app-formacao-graduacao
                [form]="$any(formacaoForm.get('graduacao'))"
                [modoEdicao]="modoEdicao()"
                [tipoFormacaoOptions]="tipoFormacaoOptions"
                [comprovanteGraduacaoOptions]="comprovanteGraduacaoOptions"
                [tiposFormacaoCarregando]="tiposFormacaoCarregando"
                [diplomasCarregando]="diplomasCarregando()"
                [prazoDiploma]="prazoDiploma"
                [prorrogarPrazoCarregando]="prorrogarPrazoCarregando()"
                [paisesOptions]="paisesOptions"
                [paisesCarregando]="paisesCarregando()"
                (pesquisarEscola)="abrirPesquisarEscola('GRAD')"
                (prorrogarPrazoDiploma)="prorrogarPrazoDiploma()"
            />
        </form>
    } @else {
        <form [formGroup]="formacaoForm">
            <app-formacao-pos
                [form]="$any(formacaoForm.get('pos'))"
                [modoEdicao]="modoEdicao()"
                [posDenominacaoOptions]="posDenominacaoOptions"
                [posDenominacoesCarregando]="posDenominacoesCarregando"
                [comprovanteGraduacaoOptions]="comprovanteGraduacaoOptions"
                (pesquisarEscola)="abrirPesquisarEscola('POS')"
                (openDenominacaoSelect)="onOpenDenominacaoSelect()"
                (abrirEspecialidades)="abrirEspecialidadesRelacionadas()"
            />
        </form>
    }

    @if (modoCreate()) {
        <div class="flex justify-end gap-2 mt-4">
            <p-button label="Cancelar" icon="pi pi-times" [text]="true" (onClick)="cancelarEdicao()" />
            <p-button label="Salvar" icon="pi pi-check" (onClick)="salvarDados()" [appCan]="roleFormacaoCriar" [appCanUf]="pessoa()?.uf" />
        </div>
    }
</app-card-content>

<app-pesquisar-escola-dialog [(showDialog)]="displayPesquisarEscola" [(tipo)]="pesquisarEscolaTipo" (saved)="onPesquisarEscolaSaved($event)" (canceled)="onPesquisarEscolaCanceled()" />
<app-especialidades-relacionadas-dialog [showDialog]="displayEspecialidadesDialog()" (showDialogChange)="displayEspecialidadesDialog.set($event)" [itens]="itensEspecialidadesRelacionadas" (closed)="onEspecialidadesDialogClosed()" />
